import { createSelector, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

import { getCommunityAccessControlCoach, createCommunityAccessControl, updateCommunityAccessControl } from '../../actions/accessControlActions'

const initialState = {
  initialAccessControl: null,
  id: null,
  enabled: false,
  description: '',
  code: '',
  errors: {},
  isLoading: null,
  isLoadingPage: null,
}

const registrationAccessCodeReducer = createSlice({
  name: 'communitySettings/accessCodePage',
  initialState,
  reducers: {
    setField: (state, action) => {
      const { field, value } = action.payload

      state[field] = value
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCommunityAccessControlCoach.pending, state => {
        state.isLoadingPage = true
      })
      .addCase(getCommunityAccessControlCoach.fulfilled, (state, action) => {
        state.isLoadingPage = false
        const accessControl = action.payload.accessControl

        const { id = null, enabled = false, description = '', code = '' } = accessControl

        state.initialAccessControl = { id, enabled, description, code }
        state.id = id
        state.enabled = enabled
        state.description = description
        state.code = code
      })

      .addCase(createCommunityAccessControl.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createCommunityAccessControl.fulfilled, (state, action) => {
        state.isLoading = false
        const accessControl = action.payload.accessControl

        const { id = null, enabled = false, description = '', code = '' } = accessControl

        state.initialAccessControl = { id, enabled, description, code }
        state.id = id
        state.enabled = enabled
        state.description = description
        state.code = code
        state.errors = {}
      })
      .addCase(createCommunityAccessControl.rejected, (state, action) => {
        state.isLoading = false
        const { general: _, ...err } = action.payload // eslint-disable-line no-unused-vars
        state.errors = err
      })

      .addCase(updateCommunityAccessControl.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateCommunityAccessControl.fulfilled, (state, action) => {
        state.isLoading = false
        const accessControl = action.payload.accessControl

        const { id = null, enabled = false, description = '', code = '' } = accessControl

        state.initialAccessControl = { id, enabled, description, code }
        state.id = id
        state.enabled = enabled
        state.description = description
        state.code = code
        state.errors = {}
      })
      .addCase(updateCommunityAccessControl.rejected, (state, action) => {
        state.isLoading = false
        const { general: _, ...attributeErrors } = action.payload // eslint-disable-line no-unused-vars
        state.errors = attributeErrors
      })
  },
})

export const { setField } = registrationAccessCodeReducer.actions

export const accessControlFormData = createSelector(
  state => state.communitySettings.accessCodePage,
  accessControlFields => ({
    enabled: accessControlFields.enabled,
    description: accessControlFields.description,
    code: accessControlFields.code,
  })
)

export const selectIsInitialStateModified = createSelector(
  [
    state => state.communitySettings.accessCodePage.initialAccessControl,
    state => state.communitySettings.accessCodePage,
  ],
  (initialAccessControlFields, currentState) => {
    if (_.isEmpty(initialAccessControlFields)) {
      return true
    }

    const { id, enabled, description, code } = currentState
    const currentAccessControlFields = { id, enabled, description, code }

    return !_.isEqual(initialAccessControlFields, currentAccessControlFields)
  }
)

export default registrationAccessCodeReducer.reducer
